import axios from 'axios'

const getListingRecommendations = (listingId) => {
  const url = `${rentler.apiBaseUri}/recommendations/listing?listingId=${listingId}`
  return axios.get(url)
}

export { getListingRecommendations }
